const phase = {
  prepare: 1,
  practice: 2,
  play: 3,
  push: 4,
};
export default phase;
